<template>
  <div class="listviewdoc">
    <list-items :items='items' :headers='headers' />
  </div>
</template>

<script>
import ListItems from '@/components/ListItems'

export default {
  name: 'adx-list-view-doc',
  components: {
    'list-items': ListItems
  },
  data(){
    return {
      items: [],
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ]
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let file = `/static/data/list.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();
        
        this.items = data.items;
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>